import React from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Info } from 'lucide-react'

interface CacheLabelProps {
  label: React.ReactNode
  message: React.ReactNode
  ariaLabel?: string
}

export const CacheLabel: React.FC<CacheLabelProps> = ({
  label,
  message,
  ariaLabel = 'Cache information',
}) => (
  <span className='inline-flex items-center gap-1'>
    {label}
    <Tooltip>
      <TooltipTrigger
        aria-label={ariaLabel}
        className='inline-flex cursor-help items-center text-muted-foreground hover:text-foreground'
      >
        <Info size={14} />
      </TooltipTrigger>
      <TooltipContent side='top'>{message}</TooltipContent>
    </Tooltip>
  </span>
)
